
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ContactHeroSection from './components/ContactHeroSection';
import ContactFormSection from './components/ContactFormSection';
import ContactInfoSection from './components/ContactInfoSection';

const ContactPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <ContactHeroSection />
        <ContactFormSection />
        <ContactInfoSection />
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
